<template>
  <b-card class="card-congratulation-medal">
    <h5>累计会诊的订单总数</h5>
    <h3 class="mb-75 mt-4">
      <b-card-text>完诊订单总数</b-card-text>
      <b-link>{{ data.num }}</b-link>
    </h3>
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    Ripple,
  },
}
</script>
